import { CourseWithChapters } from "@jelly/lesson";
import { formatLessonsForChapter } from "../../../services/Utils";
import lesson01 from "../../lesson/course-04/lesson-01/lesson";
import lesson02 from "../../lesson/course-04/lesson-02/lesson";
import lesson03 from "../../lesson/course-04/lesson-03/lesson";
import lesson04 from "../../lesson/course-04/lesson-04/lesson";
import lesson05 from "../../lesson/course-04/lesson-05/lesson";
import lesson06 from "../../lesson/course-04/lesson-06/lesson";
import lesson07 from "../../lesson/course-04/lesson-07/lesson";
import lesson08 from "../../lesson/course-04/lesson-08/lesson";
import lesson09 from "../../lesson/course-04/lesson-09/lesson";
import lesson10 from "../../lesson/course-04/lesson-10/lesson";
import lesson11 from "../../lesson/course-04/lesson-11/lesson";
import lesson12 from "../../lesson/course-04/lesson-12/lesson";
import lesson13 from "../../lesson/course-04/lesson-13/lesson";
import lesson14 from "../../lesson/course-04/lesson-14/lesson";
import lesson15 from "../../lesson/course-04/lesson-15/lesson";
import lesson16 from "../../lesson/course-04/lesson-16/lesson";
import lesson17 from "../../lesson/course-04/lesson-17/lesson";
import lesson18 from "../../lesson/course-04/lesson-18/lesson";
import lesson19 from "../../lesson/course-04/lesson-19/lesson";
import lesson20 from "../../lesson/course-04/lesson-20/lesson";
import lesson21 from "../../lesson/course-04/lesson-21/lesson";
import lesson22 from "../../lesson/course-04/lesson-22/lesson";
import lesson23 from "../../lesson/course-04/lesson-23/lesson";
import lesson24 from "../../lesson/course-04/lesson-24/lesson";
import lesson25 from "../../lesson/course-04/lesson-25/lesson";
import lesson26 from "../../lesson/course-04/lesson-26/lesson";
import lesson27 from "../../lesson/course-04/lesson-27/lesson";
import lesson28 from "../../lesson/course-04/lesson-28/lesson";
import lesson29 from "../../lesson/course-04/lesson-29/lesson";
import lesson30 from "../../lesson/course-04/lesson-30/lesson";
import case01 from "../../lesson/course-04/case-01/case";
import case02 from "../../lesson/course-04/case-02/case";
import authorMm from "./authors/author-mm";
import authorAn from "./authors/author-an";
import authorPl from "./authors/author-pl";
import authorLa from "../course-02/authors/author-la";
import authorMh from "./authors/author-mh";
import authorAp from "./authors/author-ap";
import authorFc from "./authors/author-fc";
import authorJa from "../course-02/authors/author-ja";

/* eslint-disable max-len */
const data: CourseWithChapters = {
  id: "e0db4477-1995-4380-9c35-2338dcf5e504",
  publicId: "4",
  slug: "electroacoustics",
  name: "Electroacoustics",
  description:
    "This is an online course of 30 interactive lessons on electroacoustics with two case studies for practical application.This electroacoustic course begins with a review of the necessary knowledge in electricity, mechanics, and acoustics. It then presents the various quantities that characterize audio systems. The principles of electromechanical and mechanical-acoustic transduction are elaborated upon. Once these concepts are understood, the reader will learn how to combine them to model sensors or sound sources. The course then proceeds to explain the principles behind different types of loudspeaker systems, followed by an examination of the limitations and non-linearities associated with electrodynamic loudspeakers. It concludes by discussing microphone and loudspeaker arrays, including their application in creating personal sound zones. The two case studies provided offer practical illustrations of designing a two-way loudspeaker system and conducting advanced measurements of loudspeaker parameters. Videos, interactive tasks, dynamic graphs, and multiple-choice questions will help you grasp the different concepts.",
  shortDescription:
    "This course will present, explain, and model various electro-mechanical and acoustic systems (such as shakers, geophones, microphones, loudspeakers, and enclosures) in a progressive manner, starting from simpler concepts and gradually moving towards more complex ones.",
  chapters: [
    {
      id: "a61a8e76-5090-4e15-842a-57811ae4d98d",
      name: "Background knowledge for electroacoustics (refreshers)",
      position: 0,
      chapterLessons: formatLessonsForChapter([lesson01, lesson02, lesson03, lesson04, lesson05, lesson06]),
    },
    {
      id: "4133851c-731c-4226-a453-d305d7a308d3",
      name: "Characterization of audio systems",
      position: 1,
      chapterLessons: formatLessonsForChapter([lesson07, lesson08], 5),
    },
    {
      id: "4d2e5332-cbee-4f05-8ef6-9bfce54f3a6a",
      name: "Transduction Process",
      position: 2,
      chapterLessons: formatLessonsForChapter([lesson09, lesson10, lesson11], 7),
    },
    {
      id: "94b75a91-20b2-4a48-b5bc-774c02c56263",
      name: "Modelling of transducers",
      position: 3,
      chapterLessons: formatLessonsForChapter(
        [lesson12, lesson13, lesson14, lesson15, lesson16, lesson17, lesson18, lesson19],
        10
      ),
    },
    {
      id: "bc00de65-1065-4f55-b519-98391b81ea51",
      name: "Loudspeaker systems",
      position: 4,
      chapterLessons: formatLessonsForChapter([lesson20, lesson21, lesson22, lesson23], 18),
    },
    {
      id: "057f1046-ac5e-402a-a825-4b7014ccd4b7",
      name: "Advanced modelling of loudspeaker systems",
      position: 5,
      chapterLessons: formatLessonsForChapter([lesson24, lesson25, lesson26], 22),
    },
    {
      id: "ce205b23-b383-488f-a2d7-44fcc28a293b",
      name: "Multi-transducers",
      position: 6,
      chapterLessons: formatLessonsForChapter([lesson27, lesson28, lesson29, lesson30], 25),
    },
    {
      id: "76f1890f-ade7-4b22-82f3-2b139eb478ac",
      name: "Case studies",
      position: 8,
      chapterLessons: formatLessonsForChapter([case01, case02], 30),
    },
  ],
  authors: [authorMm, authorAn, authorPl, authorLa, authorMh, authorAp, authorFc, authorJa],
};
/* eslint-enable max-len */

export default data;
